const user_auth_api =  "https://investment-tracker.tashu.qzz.io/api";
// const user_auth_api =  "https://investmentservices-production.up.railway.app/api";
// const user_auth_api =  "https://user-auth-service-production.up.railway.app/api";
// const user_auth_api = "http://localhost:3001/api";
// const user_auth_api = "http://localhost:8088/api";

export default user_auth_api;

// Open My SQL in terminal - mysql -u root -p